module.exports = "../fonts/HelveticaNeueLTW01-75Bold.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-75Bold.svg
// module id = vnKg
// module chunks = 1